import { render } from "./InstanceDetailOptions.vue?vue&type=template&id=27897a94&scoped=true&ts=true"
import script from "./InstanceDetailOptions.vue?vue&type=script&lang=ts"
export * from "./InstanceDetailOptions.vue?vue&type=script&lang=ts"

import "./InstanceDetailOptions.vue?vue&type=style&index=0&id=27897a94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27897a94"]])

export default __exports__